module.exports = __webpack_public_path__ + "img/attach.bfcaeb7c.png";